<template>
  <div class="page" :class="page">
    <div v-if="page === 'home' && bannerList.length" class="w100 carousel-box">
      <Carousel v-model="imgIndex" :arrow="isShowImg && bannerList.length > 1 ? 'hover' : 'never'" :autoplay="autoplay && bannerList.length > 1" :autoplay-speed="speed" @on-change="changeValue">
        <CarouselItem v-for="(item,i) in bannerList" :key="i">
          <div class="banner-img csp por w100" @click="changeEvent(item)">
            <img :src="item.cover_img1" alt="" class="h100 abs-c" @load="imgLoad">
          </div>
        </CarouselItem>
      </Carousel>
    </div>
    <auto-page :code="currPageCode" :show-props="showProps" class="box_width" @click-callback="changeEvent"></auto-page>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Mixins from '@/mixins/mixins';

export default {
  name: "HomePage",
  mixins: [Mixins.MakeRoute(['page'], 'params')],
  data () {
    return {
      imgIndex: 0,
      bannerList: [],
      speed: 100000000,
      autoplay: false,
      isShowImg: false,
      count: 0,
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'allGrades', 'currPageCode', 'currGrade', 'currAudio', 'currTab']),
    showProps () {
      return this.page === 'boutique' ? 'name,price,buy_num' : 'name';
    },
    page_code () {
      let code = { 1: 'banner_web_xq_v1.0.0', 2: 'banner_web_xx_v1.0.0', 3: 'banner_web_cz_v1.0.0', 4: 'banner_web_gz_v1.0.0', 5: 'banner_web_zx_v1.0.0' };
      return code[+this.currGrade.pid];
    },
    audio () {
      return this.currAudio ? this.GetAppAudio() : null;
    },
  },
  watch: {
    $route (val) {
      this.initPage();
    },
    page_code () {
      this.speed = 100000000;
      this.autoplay = false;
      this.isShowImg = false;
      this.count = 0;
      this.getBannerList();
    },
    currTab (val) {
      this.imgIndex = 0;
      this.isShowImg = val !== 'home';
    }
  },
  created () {
    this.initPage();
  },
  mounted () {

  },
  methods: {
    ...mapMutations(['setCurrTab']),
    imgLoad (e) {
      this.count++;
      this.count === 1 && this.changeValue('', 0);
      if(+this.count === +this.bannerList.length){
        this.isShowImg = true;
        this.autoplay = true;
        this.speed = 5000;
        this.count = 0;
      }
    },
    changeValue (old, index) {
      this.$nextTick(() => {
        let dom = document.querySelectorAll('.ivu-carousel-track.higher');
        if (dom && dom.length) {
          let children = new Array(...dom[0].children);
          children.forEach((e, i) => {
            e.children[0].style.background = '#ffffff';
            e.children[0].style.zIndex = i === index ? 1 : 0;
          })
        }
      })
    },
    initPage () {
      this.count = 0;
      this.setCurrTab(this.page);
      this.$emit('set-width', false);
      this.page === 'home' && !this.bannerList.length && this.getBannerList();
    },
    // 获取轮播图
    getBannerList () {
      let params = {
        page_code: this.page_code,
        uid: this.userInfo.uid,
        ...this.Product
      }
      this.bannerList = [];
      this.http.NEWAutoPage(params).then(res => {
        // 验证响应数据结构
        if (!res || !res.list || !Array.isArray(res.list)) {
          console.warn('[getBannerList] 接口返回数据格式异常:', res);
          return;
        }

        res.list.forEach(e => {
          if (e && e.element_list) {
            this.bannerList = e.element_list;
          }
        })
        this.imgIndex = 0;
      }).catch(err => {
        // 处理异常响应（如 {time: ...}）
        if (err && err.time) {
          console.warn('[getBannerList] 接口返回异常格式，可能是 Session 过期或限流:', err);
        } else {
          this.$err(err);
        }
      });
    },
    changeEvent (item) {
      let { type, element_content: content } = item;
      switch (type) {
        case 1: // 课程
          this.reopenPage(`/home/${content.format_id === 1 ? 'video' : 'audio'}/details/${content.id}/${content.type}`);
          break;
        case 2: // 专题
          this.reopenPage(`/home/specialdetail/${content.id}`);
          break;
        case 3: // 链接
          let url = item.link_url.trim();
          if (/^(https?:)?\/\//i.test(url)) {
            location.href = url;
          } else if (/^\//i.test(url)) {
            this.reopenPage(url)
          }
          break;
        case 4: // 页面
          let query = {};
          content.content.forEach(e => {
            query[e.key] = +e.value;
          })
          this.reopenPage({ name: 'HomeTbdetail', query });
          break;
        case 7: // 教师
          this.reopenPage(`/home/teacher/detail/${content.id}`);
          break;
      }
    },
    async reopenPage (url) {
      if (this.audio && this.currAudio && this.currAudio.isPlay) {
        await this.audio.ctrlCb('play');
        setTimeout(() => {
          this.OpenRouter(url);
        }, 300);
      } else {
        this.OpenRouter(url);
      }
    }
  }
}
</script>

<style scoped lang="less">
.home {
  /deep/ .ivu-carousel-arrow.right {
    right: 15%;
  }

  /deep/ .ivu-carousel-arrow.left {
    left: 15%;
  }

  /deep/ .ivu-carousel-arrow > * {
    vertical-align: -10%;
  }

  /deep/ .ivu-icon-ios-arrow-back:before {
    font-size: 20px;
  }

  /deep/ .ivu-icon-ios-arrow-forward:before {
    font-size: 20px;
  }
}
.boutique {
  /deep/ .course-card {
    align-items: flex-start;
    .detail-box {
      padding: 0;
      .course-price {
        padding: 12px 0;
      }
    }
  }
}
.box_width {
  width: 1196px;
  margin: 0 auto;
  padding: 48px 0 24px;
}

.banner-img {
  height: 400px;
}
.carousel-box {
  min-width: 1196px;
  /deep/ .ivu-carousel-dots {
    li {
      button {
        height: 4px;
        background: rgba(255, 255, 255, 0.6);
        border-radius: 2px;
      }
    }
    .ivu-carousel-active {
      button {
        background: #fff;
      }
    }
  }
}
</style>